import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconSharedModule } from '../../atoms/icon/icon.module';

import { TabsSharedComponent } from './tabs.component';

@NgModule({
    declarations: [
        TabsSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        TabsSharedComponent
    ]
})

export class TabsSharedModule {}
